/**
 * 요금개편 그랜드파더링 안내(086) — 개편 시점의 기존 유료 구독자(plan_code *_legacy)에게
 * 로그인 후 1회 안내: "구독 기간까지는 기존 사용량 유지".
 *
 * 노출 조건: plan_code 가 '_legacy' 로 끝나고 아직 닫은 적 없음(localStorage).
 * 닫으면 이 브라우저에서는 다시 안 뜬다 — 대상자가 소수(개편 시점 유료 구독자)라
 * 서버 플래그 없이 로컬 저장으로 충분하다.
 */
import { useEffect, useState } from 'react'
import { FiCheckCircle, FiGift } from 'react-icons/fi'
import Modal from '../../components/ui/Modal'
import Button from '../../components/ui/Button'
import { useAuthStore } from '../../store/authStore'

const SEEN_KEY = 'legacy-plan-notice-v1'

export default function LegacyPlanNotice() {
  const { user } = useAuthStore()
  const [open, setOpen] = useState(false)
  const isLegacy = !!user?.plan_code?.endsWith('_legacy')
  const planName = user?.plan_code?.startsWith('pro') ? '프로'
    : user?.plan_code?.startsWith('business') ? '비즈니스' : '스타터'

  useEffect(() => {
    if (!isLegacy) return
    try {
      if (!localStorage.getItem(SEEN_KEY)) setOpen(true)
    } catch { /* storage 접근 불가 환경 — 미노출 */ }
  }, [isLegacy])

  function close() {
    try { localStorage.setItem(SEEN_KEY, '1') } catch { /* noop */ }
    setOpen(false)
  }

  if (!isLegacy) return null
  return (
    <Modal isOpen={open} onClose={close} size="md" title="요금제 개편 안내">
      <div className="p-6 space-y-4">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-2xl bg-brand-primary/10">
          <FiGift className="text-brand-primary" size={22} />
        </div>
        <div className="space-y-2 text-center">
          <h3 className="text-[17px] font-bold text-ink">요금제가 새로워졌어요</h3>
          <p className="text-[13.5px] leading-relaxed text-ink-muted text-left">
            새 요금제 적용으로 플랜별 사용량(한도)이 변경되었습니다.
            다만 <b className="text-ink">지금 구독하신 {planName} 플랜은 이용 기간이 끝나는
            날까지 기존 사용량이 그대로 유지</b>되니 안심하고 쓰시면 됩니다.
          </p>
          <div className="rounded-xl border border-emerald-400/30 bg-emerald-500/[0.05] px-3.5 py-2.5 text-left">
            <p className="flex items-start gap-2 text-[12.5px] text-ink">
              <FiCheckCircle className="mt-0.5 shrink-0 text-emerald-500" size={14} />
              <span>구독 기간 중 사용량 축소 없음 — 결제하신 그대로입니다.</span>
            </p>
            <p className="mt-1 flex items-start gap-2 text-[12.5px] text-ink">
              <FiCheckCircle className="mt-0.5 shrink-0 text-emerald-500" size={14} />
              <span>이용 기간이 끝나도 <b>자동으로 결제되지 않아요</b> — 계속 쓰고 싶으시면
                그때 새 요금제를 직접 선택해 구독하시면 됩니다(가격이 더 저렴해졌어요).</span>
            </p>
          </div>
        </div>
        <Button variant="primary" className="w-full !py-2.5" onClick={close}>확인했어요</Button>
      </div>
    </Modal>
  )
}
